import {Link} from "@/components/atoms/link";
import {ProductTypeTaxonomyTerm} from "@/types/hygiena-types";
import {useContext} from "react";
import {BlurMapContext} from "@/context/blur-map-context";
import Image from "next/image";
import parse from "html-react-parser";
import classNames from "classnames";
import dynamic from "next/dynamic";
import {ARTICLE_TEASER_IMAGE_STYLE, HERO_PLACE_HOLDER_URL} from "@/types/image-styles";
import {absoluteURL} from "@/lib/absolute-url";

const MediaImage = dynamic(() => import("../media/media--image").then(mod => mod.MediaImage));

/**
 * The teaser that will display in the child category listing.
 *
 * @param taxonomy_term
 * @param className
 * @constructor
 */
export function TaxonomyProductTypeTeaser ({taxonomy_term, className}: {taxonomy_term: ProductTypeTaxonomyTerm, className?: string}) {
  const blurMap = useContext(BlurMapContext);
  const backgroundImage = taxonomy_term?.field_product_type_image;
  const displayTitle = taxonomy_term?.field_product_type_menu_title?.processed;
  const link = taxonomy_term?.field_product_type_alt_link?.url ?? taxonomy_term?.path?.alias;

  return (
    <Link href={link ?? "/"} className={classNames(
      "product-category-teaser font-semibold max-md:h-full text-lg text-center relative border bg-primary flex justify-center items-end text-white rounded-sm h-48 overflow-hidden",
      className,
    )} key={taxonomy_term.id}>
      {(backgroundImage?.image || backgroundImage?.bf_image) ? (
        <MediaImage
          media={taxonomy_term.field_product_type_image}
          className="absolute w-full h-full hover:scale-105 transition-all duration-1000"
          priority
          imageStyle={ARTICLE_TEASER_IMAGE_STYLE}
          width={300}
          height={300}
          sizes="(min-width: 968px) 25vw, 25vw"
          style={{objectFit: "cover", width: "100%", height: "100%"}}
        />
      ) : (
        <Image
          src={absoluteURL(HERO_PLACE_HOLDER_URL, true)}
          blurDataURL={blurMap?.hero_placeholder?.base64}
          placeholder={blurMap?.hero_placeholder?.base64 ? "blur" : "empty"}
          width={280}
          height={190}
          className={"absolute inset-0 w-full h-full"} style={{objectFit: "cover", height: "100%", width: "100%"}}
          alt={taxonomy_term?.name}/>
      )}
      <div className="w-full py-4 px-2 text-sm md:text-base text-left bg-hygienaLight/40 backdrop-blur text-black font-bold [&>p]:text-sm [&>p]:font-bold [&>p]:text-black [&>p]:md:text-base">
        {displayTitle ? parse(displayTitle) : taxonomy_term.name}
      </div>
    </Link>
  )
}
